<template>
  <map-picker-overlay
    v-if="isPickingOnMap"
    @close="closeMapPicker"
    @chosen="resolveMapPick"
  ></map-picker-overlay>
</template>

<script setup lang="ts">
import MapPickerOverlay from './MapPickerOverlay.vue';
import { useEditorLink } from '../composables/useEditorLink';

// Mounted once per page; the TinyMCE link dialog asks for it by flipping the
// shared flag, so no editor needs its own copy.
const { isPickingOnMap, resolveMapPick, closeMapPicker } = useEditorLink();
</script>
